module.exports = __webpack_public_path__ + "static/Lato-MediumItalic-4d295621045bd774d4beed9d6d5796e4.woff2";